import React,{ useState } from 'react';
import PropTypes from 'prop-types';
import Button from '../Button';
import './style.css';

const Menu = props => {

    return (
        <ul className="dropdown-menu" aria-labelledby={ props.label } >
            { props.children }
        </ul>
    );
}

/**
 * @name Dropdown
 * @function
 * @description Displays Dropdown
 * @returns {JSX}
 * @param {*} props 
 */
function Dropdown( props ) {

    const [ active, setActive ] = useState( undefined );

    /**
     * @name expand
     * @param {string} active The option that was just selected
     * @param {ReactDOM} button The button next to th 
     * @description This allows for the menu to expand and collapse itself without getting messy
     */
    const expand = active => setActive( active );

    /**
     * @name collapse
     * @description
     */
    const collapse = () => setActive( undefined );

    /**
     * @name select
     * @param {Object} e Browser event object 
     * @description Collapses all selected menus and sends the selection back to the filter component. 
     */
    const select = e => {
        e.preventDefault();
        collapse();
        props.callback( e );
    }   

    /**
     * @name constructOption
     * @param {array} option dropdown value 
     * @param {number} index  
     * @description Construct menu options. 
     */
    const constructOption = ( option, index ) => {
        let item = <span onClick={ select } data-value={ option.value } >{ option.value }</span>

        if( option.children ){

            let classList = [ 'dropdown', 'sub-menu' ];
            if( option.value === active ) classList.push( 'open' );

            item = (
                <div className={ classList.join( ' ' ) }>
                    <Button label={ option.value } id={ option.value } icon={ false } target="sub-menu"  callback={ expand } />
                    <Menu label={ option.value } active={ active } >
                        { option.children.map( constructOption ) }
                    </Menu>
                </div>
            )
        }

        return <li key={ `option-${ option.value }-${ index }` }>{ item }</li>;
    }

    return (
            <Menu label={ props.label }>
                { props.options.map( constructOption )}
            </Menu>
    )
}


Dropdown.propTypes = {
    callback: PropTypes.func.isRequired,
    label: PropTypes.string.isRequired
}

export default Dropdown;
